import { ContentRendererButtonBlock } from "./ContentRendererButtonBlock";
import { ContentRendererTitle } from "./ContentRendererTitle";
import { ContentRendererParagraph } from "./ContentRendererParagraph";
import { ContentRendererOffersList } from "./ContentRendererOffersList";
import { ContentRendererFactoids } from "./ContentRendererFactoids";
import { ContentRendererZigZag } from "./ContentRendererZigZag";
import { ContentRendererZigZagList } from "./ContentRendererZigZagList";
import { ContentRendererBannerCarousel } from "./ContentRendererBannerCarousel";
import { ContentRendererTextBlock } from "./ContentRendererTextBlock";
import { ContentRendererQuote } from "./ContentRendererQuote";
import { ContentRendererGridItems } from "./ContentRendererGridItems";
import { ContentRendererHero } from "./ContentRendererHero";
import { ContentRendererImage } from "./ContentRendererImage";
import { ContentRendererImageGallery } from "./ContentRendererImageGallery";
import { ContentRendererFaq } from "./ContentRendererFaq";
import { ContentRendererFeatureList } from "./ContentRendererFeatureList";

type BlockProps = {
  __component: string;
} & any;

export enum IContentBlockType {
  TITLE = "static-pages.title",
  PARAGRAPH = "static-pages.paragraph",
  PARAGPRAPH = "static-pages.paragpraph",
  TEXT_BLOCK = "static-pages.text-block",
  GRID_ITEMS = "static-pages.grid-items",
}

export const ContentRenderer = ({ __component: type, bannersSearch, ...block }: BlockProps) => {
  switch (type) {
    case "static-pages.button-block": {
      return ContentRendererButtonBlock(block);
    }
    case "static-pages.title": {
      return ContentRendererTitle(block);
    }

    case "static-pages.paragraph":
    case "static-pages.paragpraph": {
      return ContentRendererParagraph(block);
    }

    case "static-pages.offers": {
      return ContentRendererOffersList({ bannersSearch, ...block });
    }

    case "static-pages.factoids-list": {
      return ContentRendererFactoids(block);
    }

    case "static-pages.feature-list": {
      return ContentRendererFeatureList(block);
    }

    case "static-pages.zig-zag-block": {
      return ContentRendererZigZag(block);
    }

    case "static-pages.zig-zag-list": {
      return ContentRendererZigZagList(block);
    }

    case "static-pages.banner-carousel": {
      return ContentRendererBannerCarousel(block);
    }

    case "static-pages.text-block": {
      return ContentRendererTextBlock(block);
    }

    case "static-pages.quote": {
      return ContentRendererQuote(block);
    }

    case "static-pages.grid-items": {
      return ContentRendererGridItems(block);
    }

    case "static-pages.hero": {
      return ContentRendererHero(block);
    }

    case "static-pages.image": {
      return ContentRendererImage(block);
    }

    case "static-pages.image-gallery": {
      return ContentRendererImageGallery(block);
    }

    case "static-pages.faq": {
      return ContentRendererFaq(block);
    }
  }
};
